<template>
  <div id="viz">
    <div id="labels-container"></div>
    <RectArea :scene="scene" :camera="camera" v-if="loaded"/>
  </div>
</template>
<script>
/* eslint-disable no-console*/
/* eslint-disable no-unused-vars*/
const THREE = require('three') // required peer dependency
require('../custom_modules/three-orthographic-trackball-controls')
//import dat from "dat.gui";
import dat  from "../custom_modules/three-dat.gui"; // Import initialization method
//import { GeoJsonGeometry } from 'three-geojson-geometry';
import geoJson from './utils/geoJsonUtil.js';
import { GeoJsonGeometry } from 'three-geojson-geometry';
import Stats from 'stats-js'

import { mapGetters} from 'vuex'
import CityLabels from './utils/CityLabels.js';
import RectArea from '@/components/RectArea.vue'

var step = 1/30;
var width = 10;
var height = width * document.documentElement.clientHeight/window.innerWidth;

let fragmentShader =
'uniform float current;'+
'uniform float length;'+
'uniform float opacity;'+
'uniform vec3 completed;'+
'uniform vec3 ongoing;'+
'float threshold = 500.0;'+
'void main() {'+
'  if(length < threshold) {'+
'    threshold = length;'+
'  }'+
'  float alpha = current - (length - threshold);'+
'  if(alpha>0.0){'+
'    alpha = alpha/threshold;'+
'  } else {'+
'    alpha = 0.0;'+
'  }'+
'  gl_FragColor = vec4(completed * alpha + ongoing * (1.0 - alpha), 1.0);'+
'}';

var pars = {
  duration:120,
  pixelRatio:window.devicePixelRatio,
  zoomEnabled: false,
  panEnabled: false,
  rotationEnabled: false,
  staticMoving: true,
  rotationSpeed: 0.5,
  skipFrame:1,
}

var borders = [

  {year: 1920, url: 'borders-1920.json'},
  {year: 1938, url: 'borders-1938.json'},
  {year: 1945, url: 'borders-1945.json'},
  {year: 1990, url: 'borders-1990.json'},
  {year: 1991, url: 'borders-1991.json'},
  {year: 1993, url: 'borders-1993.json'},
  {year: 2006, url: 'borders-2006.json'},
  {year: 2019, url: 'borders-2019.json'},
]
export default {
  name: 'Viz',
  props: {
    debug: Boolean,
    onRender: Function
  },
  components: {
    RectArea
  },
  computed: {

    ...mapGetters(['factIndex', 'ferriesVisible', 'labelsVisible', 'detailedView', 'fps', 'path']),
    yearRoute: function(){
      return this.$route.params.year;
    },
    imgResolution: function(){
      if(window.innerWidth>768){
        return 8192;
      }
      return 4096;
      //return 2048;
    },
    alpha: {
      get() { return this.$store.state.alpha; },
      set(nr) { this.$store.commit('setAlpha', nr); },
    },
    needsRender: {
      get() { return this.$store.state.needsRender; },
      set(nr) { this.$store.commit('setNeedsRender', nr); },
    },
    resetScroll: {
      get() { return this.$store.state.resetScroll; },
      set(f) { this.$store.commit('setResetScroll', f); },
    },
    facts: {
      get() { return this.$store.state.facts; },
      set(f) { this.$store.commit('setFacts', f); },
    },
    nightMode: {
      get() { return this.$store.state.nightMode; },
      set(f) { this.$store.commit('setNightMode', f); },
    },

    year: {
      get() { return this.$store.state.year; },
      set(d) { this.$store.commit('setYear', d); },
    },
    playing:{
      get() { return this.$store.state.playing; },
      set(p) { this.$store.commit('setPlaying', p); },
    },

    fact: function(){
      if(this.factIndex>0)
      return this.facts[this.factIndex];
      else
      return undefined;
    },
    targetRotation: function(){
      if(this.nightMode){
        return Math.PI*1.5
      }
      return Math.PI*0.5
    },
    shouldAnimate: function(){
      return this.playing || this.needsRender || this.needsRotationUpdate
    },
    needsRotationUpdate:function(){
      return this.rotation != this.targetRotation
    },

    // a computed getter
    loaded: function () {
      // `this` points to the vm instance
      return this.loadingProgress>=100;
    },
    loadingProgress:{
      get() { return this.$store.state.loadingProgress; },
      set(p) { this.$store.commit('setLoadingProgress', p); },
    },
    path: function(){
      return this.$route.path;
    },
    routeId: function(){
      return this.$route.params.year;
    },
  },
  watch: {
    detailedView: function(val){
      this.needsRender = true;
    },
    targetRotation: function(val){
      if(step==1)
      this.rotation = this.targetRotation;
    },
    rotation: function(val){
      this.dLight.position.x = Math.sin(this.rotation)*20;
      this.dLight.position.y = Math.cos(this.rotation)*20;

    },
    nightMode: function (val) {
    },
    ferriesVisible: function(val){
      if(val)
      this.ferriesMaterial.opacity = 1;
      else
      this.ferriesMaterial.opacity = 0;

      this.needsRender = true;
    },
    labelsVisible: function(val){
      this.cityLabels.setVisible(val);
      this.needsRender = true;
    },
    year: function (val) {
      if(val != 1920 + Math.round(100*this.alpha)){
        this.alpha = (val-1920)/100;
      }
      if(val == 2020){
        this.playing = false
      }
    },
    playing: function (val) {
      if(val)this.resetScroll = true;
    },
    needsRender: function (val) {
      this.currentFrame=pars.skipFrame;
    },

    loaded: function (val) {
      this.cityLabels = new CityLabels(this.renderer, this.camera, this.scene);
      this.lastYear = -1;
      this.animate()
    },
    path: function(p){
      if(p =='/gui'){
        this.setupGui();
        this.stats = new Stats();
        document.body.appendChild( this.stats.dom );
      }
    },
    factIndex:function(p){
      this.cityLabels.setFact(p);
    }
  },
  data() {
    return {
      publicPath: process.env.BASE_URL,
      gui: null,
      scene: new THREE.Scene(),
      camera: new THREE.OrthographicCamera( width / - 2, width / 2, height / 2, height / - 2, 0.1, 40 ),
      renderer: null,
      lines:[],
      currentFrame:0,
      lastRender: performance.now(),
      borderMap:{},
      lineMaterial: new THREE.ShaderMaterial( {
        uniforms: {
          current: { value: 0.0 },
          length: { value: 1.0 },
          opacity: { value: 1.0 },
          completed: {value: new THREE.Vector3(0.992,0.427,0.427)},
          ongoing: {value: new THREE.Vector3(1.0,1.0,1.0)}

        },
        transparent:true,
        depthTest: false,
        fragmentShader: fragmentShader
      }),
      /*lineMaterial: new THREE.LineBasicMaterial( {
      linewidth: 1,
      color: 'rgb(255, 255, 255)', //0x22ccee,
      linecap: 'round', //ignored by WebGLRenderer
      linejoin:  'round', //ignored by WebGLRenderer
      depthTest: false,
      transparent:true,
      opacity:1,

      depthTest: false,

    } ),*/
    borderlineMaterial: new THREE.LineBasicMaterial({
      linewidth: 1,
      color: 'rgb(0, 0, 0)', //0xaaaaaa,
      linecap: 'round', //ignored by WebGLRenderer
      linejoin:  'round', //ignored by WebGLRenderer
      depthTest: false,
      transparent:true,
      opacity:0.20,

    } ),
    completedLineMaterial:new THREE.LineBasicMaterial( {
      color: 'rgb(253, 109, 109)', //0xffffff,
      linewidth: 1,
      linecap: 'round', //ignored by WebGLRenderer
      linejoin:  'round', //ignored by WebGLRenderer
      depthTest: false,
      transparent:true,
      opacity:1,

    } ),
    tentMaterial:new THREE.LineBasicMaterial( {
      color: 'rgb(255, 255, 255)',//0x444444,
      linewidth: 1,
      transparent:true,
      opacity:0,
      linecap: 'round', //ignored by WebGLRenderer
      linejoin:  'round', //ignored by WebGLRenderer
      depthTest: false
    } ),
    pantMaterial:new THREE.LineBasicMaterial( {
      color: 'rgb(255, 255, 255)',//0x444444,
      linewidth: 1,
      transparent:true,
      opacity:0,
      linecap: 'round', //ignored by WebGLRenderer
      linejoin:  'round', //ignored by WebGLRenderer
      depthTest: false
    } ),
    eroadsMaterial:new THREE.LineBasicMaterial( {
      color: 'rgb(118, 118, 118)',//0x444444,
      linewidth: 1,
      transparent:true,
      opacity:0,
      linecap: 'round', //ignored by WebGLRenderer
      linejoin:  'round', //ignored by WebGLRenderer
      depthTest: false
    } ),
    siberianSecondaryMaterial:new THREE.LineBasicMaterial( {
      color: 'rgb(255, 255, 255)',//0x444444,
      linewidth: 1,
      transparent:true,
      opacity:0,
      linecap: 'round', //ignored by WebGLRenderer
      linejoin:  'round', //ignored by WebGLRenderer
      depthTest: false
    } ),
    siberianPrincipalMaterial:new THREE.LineDashedMaterial({
      color: 'rgb(255, 255, 255)',//0x444444,
      linewidth: 1,
      transparent:true,
      opacity:0,
      scale: 1,
      dashSize: 0.04,
      gapSize: 0.04,
      depthTest: false
    } ),
    ferriesMaterial:new THREE.LineDashedMaterial({
      color: 'rgb(118, 118, 118)',//0x444444,
      linewidth: 1,
      transparent:true,
      opacity:0,
      scale: 1,
      dashSize: 0.02,
      gapSize: 0.02,
      depthTest: false
    } ),
    rotation: 0
  };
},

created: function() {

  this.rotation = Math.PI*1.5;
  for(var i=1; i<this.facts.length; i++){
    if(i<this.facts.length-1){
      if(this.onRender){
        if(this.facts[i].end_year) this.facts[i].alpha_year = this.facts[i].end_year
        else this.facts[i].alpha_year = this.facts[i].year
      } else {
        this.facts[i].alpha_year =Math.min(this.facts[i].year+5,this.facts[i+1].year - 1);
      }
    }
    else
    this.facts[i].alpha_year = 2020
  }

  //New scene and camera

  //RENDERER
  this.renderer = new THREE.WebGLRenderer({ preserveDrawingBuffer: true, antialias: true });
  this.renderer.setSize(window.innerWidth, document.documentElement.clientHeight);
  this.renderer.setPixelRatio(pars.pixelRatio)
  this.renderer.antialias = true
  this.renderer.domElement.id = 'canvas';
  document.body.prepend(this.renderer.domElement);




  //**********************************************
  //CAMERA
  var res = 360;
  var geometry = new THREE.SphereBufferGeometry(9.99, res, res);
  /*
  var lx = res *14/36;
  var w = res * 10/36;
  var h = w;
  var ty = res *2/36;
  for(var y=0; y<=res; y++){
  for(var x=0; x<=res; x++){
  var xx = Math.min(1, Math.max(0,(x-lx)/w))
  var yy = Math.min(1, Math.max(0, ((res-y)-ty)/h))
  geometry.attributes.uv.array[(res-y)*((res+1)*2) + x*2] = xx//x/36
  geometry.attributes.uv.array[(res-y)*((res+1)*2) + x*2 + 1] = 1-yy//y/36
}
}*/
var material = new THREE.MeshPhongMaterial({
  color: 0xffffff,
  bumpMap: new THREE.TextureLoader().load( require('@/assets/bumpMap_'+this.imgResolution+'.jpg'), ()=>{ this.assetLoaded();} ),
  bumpScale:0.03,
  displacementScale:0.0,
  map: new THREE.TextureLoader().load( require('@/assets/colorMap_'+this.imgResolution+'_compressed.jpg'), ()=>{ this.assetLoaded();}  ),
  // displacementMap: texture,
  depthTest: false,
  shininess:2
});


//Ambient Light
this.aLight = new THREE.AmbientLight( 0x222222 ); // soft white light
this.aLight.intensity = 1;
this.scene.add( this.aLight );
//this.scene.scale.set(1920/width,1080/height,1);
//Directional Light
this.dLight =  new THREE.PointLight( 0xffffff, 1, 2 );
this.dLight.intensity = 1;
this.dLight.power = 12;

this.dLight.position.y = 0;
this.dLight.position.x = 100;
this.dLight.position.z = 10;
this.dLight.decay = 0;
this.dLight.intensity = 1;


this.scene.add( this.dLight );

this.sphere = new THREE.Mesh(geometry, material);
this.sphere.rotation.x =0.5*Math.PI;
// this.sphere.rotation.z += 0.0004*Math.PI;
this.sphere.rotation.y -= 0.0006*Math.PI;

this.scene.rotation.x = 5// 1.77*Math.PI
this.scene.rotation.y = 0
this.scene.rotation.z = -2.03// -0.55*Math.PI;

this.scene.position.x = 0.73
this.scene.position.y = -5.7
this.scene.position.z = 0

this.renderer.sortObjects = true;

this.loadJSON('tent-principale.json',(data)=>{
  data.features.forEach(({ properties, geometry }) => {
    if(geometry.coordinates.length>0){
      let parsedLines = new geoJson.parseStaticGeoJsonFeature(geometry, 10);
      for(let i = 0; i<parsedLines.length; i++){
        let ll = new THREE.LineSegments( parsedLines[i].geometry, this.tentMaterial );
        ll.renderOrder = 6;
        this.scene.add( ll );
      }
    }
  })
  this.assetLoaded();
});

this.loadJSON('pan-european.json',(data)=>{
  data.features.forEach(({ properties, geometry }) => {
    if(geometry.coordinates.length>0){
      let parsedLines = new geoJson.parseStaticGeoJsonFeature(geometry, 10);
      for(let i = 0; i<parsedLines.length; i++){
        let ll = new THREE.LineSegments( parsedLines[i].geometry, this.pantMaterial );
        ll.renderOrder = 6;
        this.scene.add( ll );
      }
    }
  })
  this.assetLoaded();
})

this.loadJSON('e-roads_001_dissolved.json',(data)=>{
  data.features.forEach(({ properties, geometry }) => {
    if(geometry.coordinates.length>0){
      let parsedLines = new geoJson.parseStaticGeoJsonFeature(geometry, 10);
      for(let i = 0; i<parsedLines.length; i++){
        let ll = new THREE.LineSegments( parsedLines[i].geometry, this.eroadsMaterial );
        ll.renderOrder = 2;
        this.scene.add( ll );
      }
    }
  })
  this.assetLoaded();
})

this.loadJSON('russian-meridian-highway_secondaria.json',(data)=>{
  data.features.forEach(({ properties, geometry }) => {
    if(geometry.coordinates.length>0){
      let parsedLines = new geoJson.parseStaticGeoJsonFeature(geometry, 10);
      for(let i = 0; i<parsedLines.length; i++){
        let ll = new THREE.LineSegments( parsedLines[i].geometry, this.siberianSecondaryMaterial );
        ll.renderOrder = 6;

        this.scene.add( ll );
      }
    }
  })
  this.assetLoaded();
})

this.loadJSON('russian-meridian-highway_principale.json',(data)=>{
  data.features.forEach(({ properties, geometry }) => {
    if(geometry.coordinates.length>0){
      let parsedLines = new geoJson.parseStaticGeoJsonFeature(geometry, 10);

      for(let i = 0; i<parsedLines.length; i++){
        let pp = parsedLines[i].geometry.getAttribute ('position').array;
        let ii = parsedLines[i].geometry.getIndex();
        let g = new THREE.Geometry();
        /*for(let j = 0; j<ii; j++) {
        const iii=ii[j];
        g.vertices.push (new THREE.Vector3 (pp[3*iii], pp[3*iii+1], pp[3*iii+2]));
      }*/
      for (var j = 0; j < pp.length-3; j+=3) {
        g.vertices.push (new THREE.Vector3 (pp[j], pp[j+1], pp[j+2]));
        g.vertices.push (new THREE.Vector3 (pp[j+3], pp[j+4], pp[j+5]));
      }
      let ll = new THREE.LineSegments(g , this.siberianPrincipalMaterial );
      ll.computeLineDistances();
      ll.renderOrder = 6;
      this.scene.add( ll );

    }
  }
})

this.assetLoaded();
})


this.loadJSON('ferries.json',(data)=>{
  data.features.forEach(({ properties, geometry }) => {
    if(geometry.coordinates.length>0){
      let parsedLines = new geoJson.parseStaticGeoJsonFeature(geometry, 10);

      for(let i = 0; i<parsedLines.length; i++){
        let pp = parsedLines[i].geometry.getAttribute ('position').array;
        let ii = parsedLines[i].geometry.getIndex();
        let g = new THREE.Geometry();
        /*for(let j = 0; j<ii; j++) {
        const iii=ii[j];
        g.vertices.push (new THREE.Vector3 (pp[3*iii], pp[3*iii+1], pp[3*iii+2]));
      }*/
      for (var j = 0; j < pp.length-3; j+=3) {
        g.vertices.push (new THREE.Vector3 (pp[j], pp[j+1], pp[j+2]));
        g.vertices.push (new THREE.Vector3 (pp[j+3], pp[j+4], pp[j+5]));
      }
      let ll = new THREE.LineSegments(g , this.ferriesMaterial );
      ll.computeLineDistances();
      ll.renderOrder = 4;

      this.scene.add( ll );

    }
  }
})
this.assetLoaded();
})

this.loadJSON('borders-fixed.json',(data)=>{
  data.features.forEach(({ properties, geometry }) => {
    if(geometry.coordinates.length>0){
      let parsedLines = new geoJson.parseStaticGeoJsonFeature(geometry, 10);
      for(let i = 0; i<parsedLines.length; i++){
        let ll = new THREE.LineSegments( parsedLines[i].geometry, this.borderlineMaterial);
        ll.renderOrder = 1;
        this.scene.add( ll );
      }
    }
  })
  this.assetLoaded();
})

for(let i=0;i<borders.length;i++) {
  this.loadJSON(borders[i].url,(json)=>{
    json.features.forEach(({ properties, geometry }) => {
      if(geometry.coordinates.length>0){
        let parsedLines = new geoJson.parseStaticGeoJsonFeature(geometry, 10);
        for(let j = 0; j<parsedLines.length; j++){
          borders[i].line = new THREE.LineSegments( parsedLines[j].geometry, this.borderlineMaterial.clone());
          // borders[i].line.visible = false;
          borders[i].line.renderOrder = 1;
          this.scene.add( borders[i].line );
        }
      }
    })
    this.assetLoaded()
  })
}

/*
this.lineMaterial.extensions = {
derivatives: true, // set to use derivatives
fragDepth: true, // set to use fragment depth values
drawBuffers: true, // set to use draw buffers
shaderTextureLOD: true // set to use shader texture LOD
};
*/
/*
this.lineMaterial = new THREE.ShaderMaterial( {
uniforms: {
current: { value: 0.0 },
length: { value: 1.0 },
opacity: { value: 1.0 },
completed: {value: new THREE.Vector3(0.992,0.427,0.427)},
ongoing: {value: new THREE.Vector3(1.0,1.0,1.0)}

},

depthTest: false,
fragmentShader: fragmentShader
})


this.lineMaterial = new THREE.LineBasicMaterial({
linewidth: 1,
color: 'rgb(0, 255, 0)', //0xaaaaaa,
depthTest: false,
transparent:true,

} );
*/
this.loadJSON('data_00001.min.json',(data)=>{
  data.features.forEach(({ properties, geometry }) => {
    if(geometry.coordinates.length>0){
      let l = new geoJson.parseGeoJsonFeature(geometry, 10)[0];
      l.geometry.setDrawRange(0,0);
      l.line = new THREE.Line( l.geometry, this.lineMaterial.clone() );
      l.duration = 0.03;
      if(!isNaN(properties.end_year)  && properties.end_year>0){
        if(!isNaN(properties.start_year)  && properties.start_year>0) {
          l.duration = Math.min(100, Math.max(1, properties.end_year - properties.start_year))/100-0.005
        }
        l.start = (Math.min(2020, Math.max(1920, properties.end_year))-1920)/100 - l.duration
      }
      else{
        l.start = 0.4+Math.random()*0.2;
        l.duration = 0.11;

      }

      l.line.renderOrder = 5;
      this.scene.add( l.line );
      this.lines.push(l);
      // mx=Math.max(mx, l.length)
    }
  })
  this.assetLoaded();
})


this.scene.add(this.sphere);

//Set the camera position
this.camera.position.z = 30;

//Enable controls
this.controls = new THREE.OrthographicTrackballControls(this.camera, this.renderer.domElement);
//Render the image
const onWindowResize = ()=> {

  this.$store.commit('setMobile', (window.innerWidth <1023  ||   window.innerHeight < 600))

  width = 1920*0.005;
  height = 1920*0.005*document.documentElement.clientHeight/window.innerWidth;
  this.camera.left = width / - 2;
  this.camera.right = width / 2;
  this.camera.top = height / 2;
  this.camera.bottom = height / - 2;
  this.camera.updateProjectionMatrix();
  this.renderer.setSize(window.innerWidth, document.documentElement.clientHeight);
  if(this.cityLabels)this.cityLabels.updatePosition();
  this.needsRender = true;
}
onWindowResize();
window.addEventListener('resize', onWindowResize, false);
if(this.path=="/gui")this.setupGui();

},
mounted: function() {
  window.scrollTo(0,0);
  //CONTROLS
  this.controls.rotateSpeed = pars.rotationSpeed;
  this.controls.staticMoving = pars.staticMoving;
  this.controls.noZoom = !pars.zoomEnabled;
  this.controls.noRotate = !pars.rotationEnabled;
  this.controls.noPan = !pars.panEnabled;


  for(let y=1920; y<=2020; y++){
    let cbi = -1;
    for(let i = 0; i<borders.length-1; i++) {
      if(y+1 >= borders[i].year && y+1 < borders[i+1].year) {
        cbi = i;
        break;
      }
    }
    if(cbi<0) cbi = borders.length-1
    this.borderMap[y] =cbi
  }
},
methods: {
  loadJSON: function(path, callback){
    fetch(this.publicPath+'data/min/'+path).then(response => response.json())
    .then(data => {
      callback(data);
    })
  },
  assetLoaded: function(){
    this.loadingProgress += 100.0/(18);
  },
  updateSunlight: function () {
    if(this.needsRotationUpdate){
      let incr =  (Math.abs(this.rotation-this.targetRotation) + 0.1) * step * 0.5
      if(this.onRender) incr = incr/3
      let newRotation = this.rotation + incr;
      if(newRotation>=Math.PI *2)
      newRotation = 0;

      if(newRotation<this.rotation)
      this.rotation=0;
      if(this.rotation<=this.targetRotation && this.targetRotation<=newRotation)
      this.rotation = this.targetRotation;
      else
      this.rotation = newRotation;
    }
  },

  updateBorders: function(){
    let cbi = this.borderMap[this.year]
    const o = this.borderlineMaterial.opacity;
    for(let i = 0; i<borders.length; i++) {
      if(i==cbi) {
        if(borders[i].line.material.opacity<o){
          borders[i].line.material.opacity=Math.min(o, borders[i].line.material.opacity+step);
          this.needsRender = true
        }
      }
      else{
        if(borders[i].line.material.opacity>0){
          borders[i].line.material.opacity = Math.max(0, borders[i].line.material.opacity-step);
          this.needsRender = true
        }
      }
    }
  },

  updateLines: function(){
    const threshold = 0.01;
    let small_step = step*0.3, medium_step = step*0.7;
    if(this.onRender){
      small_step = step * 0.15
      medium_step = step * 0.35
    }
    if(this.factIndex==12) {
      if(this.siberianPrincipalMaterial.opacity<1){
        this.siberianPrincipalMaterial.opacity = Math.min(1, this.siberianPrincipalMaterial.opacity + small_step)
        this.siberianSecondaryMaterial.opacity = this.siberianPrincipalMaterial.opacity
        const alpha = Math.sin(this.siberianPrincipalMaterial.opacity * 1.57079633)
        this.scene.rotation.z = -2.03 - 1.1 * (alpha);
        this.camera.zoom = 1.0 - alpha * 0.3
        this.needsRender = true;
        this.cityLabels.updatePosition()
        if(this.labelsVisible)this.cityLabels.updatePosition();
      }
    } else if(this.siberianPrincipalMaterial.opacity>0){
      this.siberianPrincipalMaterial.opacity = Math.max(0, this.siberianPrincipalMaterial.opacity - small_step)
      this.siberianSecondaryMaterial.opacity = this.siberianPrincipalMaterial.opacity
      const alpha = 1 - Math.sin(this.siberianPrincipalMaterial.opacity * 1.57079633 + Math.PI *0.5)
      this.scene.rotation.z = -2.03 - 1.1 * (alpha);
      this.camera.zoom = 1.0 - alpha * 0.3
      this.cityLabels.updatePosition()
      this.needsRender = true;
      this.cityLabels.updatePosition();
    }

    if(this.year < this.facts[8].year || (this.detailedView && (this.factIndex == 11 || this.factIndex == 10))){

      if(this.eroadsMaterial.opacity>0){
        this.eroadsMaterial.opacity = Math.max(0, this.eroadsMaterial.opacity - medium_step)
        this.needsRender = true
      }
    } else {
      if(this.eroadsMaterial.opacity<1){
        this.eroadsMaterial.opacity = Math.min(1, this.eroadsMaterial.opacity + medium_step)
        this.needsRender = true;
      }
    }
    if(this.detailedView && this.factIndex==10) {
      if(this.dLight.intensity>0){
        this.dLight.intensity = Math.max(0, this.dLight.intensity - medium_step)
        const di = this.dLight.intensity
        for(let k=0; k<this.lines.length; k++)
        this.lines[k].line.material.uniforms.opacity.value = di;
        this.pantMaterial.opacity = 1 - di;
        this.tentMaterial.opacity = 0
        this.needsRender = true

      }
    } else if(this.detailedView && this.factIndex==11) {
      if(this.dLight.intensity>0){
        this.dLight.intensity = Math.max(0, this.dLight.intensity - medium_step)
        const di = this.dLight.intensity
        for(let k=0; k<this.lines.length; k++)
        this.lines[k].line.material.uniforms.opacity.value = di;
        this.tentMaterial.opacity = 1 - di;
        this.pantMaterial.opacity = 0
        this.needsRender = true
      }
    } else if(this.detailedView && this.factIndex==8) {
      if(this.dLight.intensity>0){
        this.dLight.intensity = Math.max(0, this.dLight.intensity - medium_step)
        const di = this.dLight.intensity
        for(let k=0; k<this.lines.length; k++)
        this.lines[k].line.material.uniforms.completed.value = new THREE.Vector3(0.992 * di + (1-di),0.427 * di + (1-di),0.427 * di + (1-di));
        const erc= Math.round(255 - (255-118) * di);
        this.eroadsMaterial.color = new THREE.Color('rgb('+erc+', '+erc+', '+erc+')');
        this.pantMaterial.opacity = this.tentMaterial.opacity = 0
        this.needsRender = true
      }
    } else {
      if(this.dLight.intensity<1) {
        this.dLight.intensity = Math.min(1, this.dLight.intensity + medium_step)
        const di = this.dLight.intensity
        for(let k=0; k<this.lines.length; k++){
          this.lines[k].line.material.uniforms.opacity.value = Math.max(this.lines[k].line.material.uniforms.opacity.value, di);
          this.lines[k].line.material.uniforms.completed.value = new THREE.Vector3(0.992 * di + (1-di),0.427 * di + (1-di),0.427 * di + (1-di));
        }
        this.tentMaterial.opacity = Math.min(this.tentMaterial.opacity, 1 - di);
        this.pantMaterial.opacity = Math.min(this.pantMaterial.opacity, 1 - di);
        const erc= Math.round(255 - (255-118) * di);
        this.eroadsMaterial.color = new THREE.Color('rgb('+erc+', '+erc+', '+erc+')');
        this.needsRender = true
      }

    }

    for(var i=0; i<this.lines.length; i++) {
      var lineAlpha = Math.min(1, Math.max(0, (this.alpha-this.lines[i].start)/this.lines[i].duration));
      const dr = Math.round((this.lines[i].length/3) * lineAlpha);
      this.lines[i].line.geometry.setDrawRange(0, dr);
      this.lines[i].line.material.uniforms.current.value = dr;
      this.lines[i].line.material.uniforms.length.value = (this.lines[i].length/3);
      /*
      if(lineAlpha == 1){
      this.lines[i].line.material = this.completedLineMaterial;
    }
    else {
    this.lines[i].line.material = this.lineMaterial;
  }*/
}
},
animate: function(){
  const now = performance.now();
  const delta = (now - this.lastRender)/1000;
  step = delta;
  if(this.onRender){
    pars.skipFrame = 0
    step = 1.0/this.fps;
  }
  if(this.shouldAnimate){
    if(this.currentFrame>=pars.skipFrame){
      this.needsRender = false;
      if(this.stats) this.stats.begin()
      if(this.playing && !this.detailedView){
        const increment = (delta)/pars.duration;
        this.alpha = Math.min(1, this.alpha + increment);
      }
      if(this.onRender) this.year = 1920 + Math.floor(100*this.alpha);
      else this.year = 1920 + Math.round(100*this.alpha);
      this.updateSunlight();
      this.updateBorders();
      this.updateLines();

      this.camera.updateProjectionMatrix();
      this.controls.update();

      this.renderer.render(this.scene, this.camera);
      this.currentFrame = 0;
      if(this.stats)this.stats.end();
      this.lastRender = now;
    } else{
      this.currentFrame+=1;
    }
  } else{
    this.lastRender = now;
  }
  if(this.onRender) this.onRender();
  requestAnimationFrame(this.animate);
},
setupGui: function () {
  // this.gui.addScene("scene_set", this.scene);
  this.gui = new dat.GUI();

  this.gui.addCamera('cam', this.camera)

  let generalF = this.gui.addFolder('general')
  // generalF.add(pars, 'alpha', 0, 1).listen().onFinishChange(()=>{this.needsRender=true;});
  generalF.add(pars, 'duration', 0, 200);
  generalF.add(this, 'playing').listen();
  // generalF.add(pars, 'scrollHeight', 0, 10000).onFinishChange(()=>{ this.scrollHeight = pars.scrollHeight;});

  generalF.add(pars, 'pixelRatio', 0.1, 3).step(0.2).onFinishChange(()=>{this.renderer.setPixelRatio(pars.pixelRatio)});
  generalF.add(pars, 'skipFrame', 0, 120).listen()

  let sceneF = this.gui.addFolder('scene')
  sceneF.addVector('rotation', this.scene.rotation, {step:0.01})
  sceneF.addVector('position', this.scene.position, {step:0.01})

  // this.gui.addMesh("earth", this.sphere);
  let materialF = this.gui.addFolder('materials')
  materialF.addMaterial("basemap_material", this.sphere.material);
  materialF.addMaterial("line_material", this.lineMaterial);
  materialF.addMaterial("borderline_material", this.borderlineMaterial);
  materialF.addMaterial("eroads_material", this.eroadsMaterial);
  materialF.addMaterial("completed_line_material", this.completedLineMaterial);
  materialF.addMaterial("ferries_material", this.ferriesMaterial);
  materialF.addMaterial("tent_material", this.tentMaterial);
  materialF.addMaterial("pant_material", this.pantMaterial);
  const dashedF = materialF.addFolder("ferries_dashed")
  dashedF.add(this.ferriesMaterial, 'scale',0,5).onFinishChange(()=>{this.ferriesMaterial.needsUpdate = true;});
  dashedF.add(this.ferriesMaterial, 'gapSize',0,0.1).onFinishChange(()=>{this.ferriesMaterial.needsUpdate = true;});
  dashedF.add(this.ferriesMaterial, 'dashSize',0,0.1).onFinishChange(()=>{this.ferriesMaterial.needsUpdate = true;});
  let lightF = this.gui.addFolder('light')
  lightF.addLight("ambient_light", this.aLight)
  lightF.addLight("point_light", this.dLight)



  const c = this.gui.addFolder('controls');
  c.add(pars, 'zoomEnabled').onFinishChange((v)=>{
    this.controls.noZoom = !v;
  });
  c.add(pars, 'panEnabled').onFinishChange((v)=>{
    this.controls.noPan = !v;
  });
  c.add(pars, 'rotationEnabled').onFinishChange((v)=>{
    this.controls.noRotate = !v;
  });
  c.add(pars, 'staticMoving').onFinishChange((v)=>{
    this.controls.staticMoving = v;
  });
  c.add(pars, 'rotationSpeed', 0, 10).onFinishChange((v)=>{
    this.controls.rotateSpeed = v;
  });

  this.stats = new Stats();
  document.body.appendChild( this.stats.dom );

  var f = ()=>{this.needsRender=true;};
  function addOnFinishChange(folder, f){
    let i;
    for (i in folder.__controllers) folder.__controllers[i].onFinishChange (f);
    for (i in folder.__folders) addOnFinishChange(folder.__folders[i], f)
  }

  addOnFinishChange(materialF, f)
  addOnFinishChange(lightF, f)
  addOnFinishChange(sceneF, f)


},
}
}
</script>

<style lang="scss">

#canvas{
  position:fixed;
  top:0px;
  left:0px;
  z-index:0;
}

.dg.ac{
  z-index:1000;
}

#labels-container {
  position:fixed;
  width: 100%;
  height: 100%;
  left:0px;;
  top:0px;
  z-index:0;
  pointer-events: none;
  transition: opacity 0.5s ease-in-out;
  >*{
    transition: opacity 0.5s ease-in-out;
    transform: translate(0.23rem, -0.43rem);
  }
}

.text-label {
  color: #fff;
  font-size: 0.75rem;
  font-weight: lighter;
  transform: translate(0.3rem, -0.4rem);
}
</style>
